var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag",class:[("tag-" + _vm.tagType), { show: _vm.label > 0 }]},[_vm._v(" "+_vm._s(_vm._f("labelText")(_vm.label))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }